"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "progressbar" };
const _hoisted_2 = { class: "inner-container" };
const _hoisted_3 = { class: "flex items-center" };
const _hoisted_4 = { class: "img-block" };
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = { class: "text-block" };
const _hoisted_7 = { class: "indicator" };
const vue_3 = require("vue");
const i18n_1 = __importDefault(require("../../../common/i18n"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProgressBar',
    props: {
        step: {
            type: Number,
            default: 1,
        },
    },
    setup(__props) {
        const props = __props;
        const Progresses = {
            1: {
                label: i18n_1.default.trans("car_datas", "Car Datas", "progressbar"),
                icon: "auto_adatok.png",
                percent: 8,
            },
            2: {
                label: i18n_1.default.trans("location", "Location", "progressbar"),
                icon: "szerviz.png",
                percent: 23,
            },
            3: {
                label: i18n_1.default.trans("tyre_datas", "Tyre datas", "progressbar"),
                icon: "abroncs_adatok.png",
                percent: 39,
            },
            4: {
                label: i18n_1.default.trans("service", "Service", "progressbar"),
                icon: "szolgaltatas.png",
                percent: 59,
            },
            5: {
                label: i18n_1.default.trans("appointment", "Appointment", "progressbar"),
                icon: "idopont.png",
                percent: 76,
            },
            6: {
                label: i18n_1.default.trans("contact", "Contact", "progressbar"),
                icon: "elerhetoseg.png",
                percent: 100,
            },
        };
        const currentProgress = (0, vue_3.computed)(() => Progresses[props.step].percent);
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(Progresses, (progress, index) => {
                            return (0, vue_2.createElementVNode)("div", {
                                key: index,
                                class: "uppercase ml-auto mr-auto"
                            }, [
                                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                    (0, vue_2.createElementVNode)("img", {
                                        src: require(`../../../images/frontend/${progress.icon}`),
                                        alt: progress.label
                                    }, null, 8, _hoisted_5)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)(progress.label), 1)
                            ]);
                        }), 64))
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_7, [
                        (0, vue_2.createElementVNode)("div", {
                            class: "charge",
                            style: (0, vue_2.normalizeStyle)(`width: ${currentProgress.value}%`)
                        }, null, 4)
                    ])
                ])
            ]));
        };
    }
});
